import React from "react";
import { aybAttributeService } from "../jwt/_services/ayb/aybAttributeService";

export const aybAttributeProvider = {
    getOptions,
    getItem
};

async function getOptions() {
    try {
        const dataRequest = {
            fbDataBase:  null,
            item: {
                code : null
            }
        }
        const listItems = await aybAttributeService.search(0,1000, dataRequest)
        return listItems.data.map((itemData) => {
            return (
                {
                    id: itemData.id,
                    value: itemData.code + " - " + itemData.title,
                    label: <div><label>{ itemData.title }</label></div>
                }
            )
        });
    } catch (error) {
        console.log(error.message);
    }
}


async function getItem(id) {
    try {
        const item = await aybAttributeService.getItem(id);

        return (
            {
                id: item.id,
                value: item.code,
                label: <div><label>{item.code}</label></div>
            }
        );
    } catch (error) {
        console.log(error.message);
    }
}